import React, { useCallback, useEffect, useState, useRef } from "react";
import {
  useAuthUser,
  withAuthUser,
  withAuthUserTokenSSR,
} from "next-firebase-auth";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Head from "next/head";
//import Link from 'next/link';
import {
  Row,
  Container,
  Col,
  Button,
  Form,
  FormGroup,
  FormFeedback,
  Label,
  Input,
  Alert,
} from "reactstrap";
import * as ga from "../lib/ga";

const { API_HOST } = require("../constants");

const wordCount = (text: string) => text.trim().split(/\s+/).length;

const Contact = () => {
  const AuthUser = useAuthUser();
  const [name, setName] = useState<string>();
  const [email, setEmail] = useState<string>(
    AuthUser?.email ? AuthUser.email : ""
  );
  const [message, setMessage] = useState<string>();
  const [website, setWebsite] = useState<string>("");
  const startedAt = useRef<number>(Date.now());
  const [formSubmitted, setFormSubmitted] = useState<boolean>(false);
  const [submitted, setSubmitted] = useState<boolean>(false);

  const validForm = () => {
    setFormSubmitted(true);
    if (
      name &&
      name.length <= 64 &&
      email &&
      email.length <= 64 &&
      message &&
      message.length > 5 &&
      wordCount(message) >= 2
    ) {
      return true;
    }
    return false;
  };

  const postMessageData = async () => {
    const token = await AuthUser.getIdToken();
    const endpoint = API_HOST + "/message";
    try {
      const response = await fetch(endpoint, {
        method: "POST",
        mode: "cors", // no-cors, *cors, same-origin
        //cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: "same-origin", // include, *same-origin, omit
        body: JSON.stringify({
          name: name,
          email: email,
          message: message,
          website: website,
          startedAt: startedAt.current,
        }),
        headers: {
          Authorization: token ? token : "",
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();
      if (!response.ok) {
        // eslint-disable-next-line no-console
        console.error(
          `Data fetching failed with status ${
            response.status
          }: ${JSON.stringify(data)}`
        );
        return null;
      }
      console.log(data);
      setSubmitted(true);
      /*if (data.insertId) {
        //setShowOrgForm(false);
        //fetchDetails();
        Router.push('/jobs/add')
      }*/
      return data;
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <Head>
        <title>Get in touch with the team at Vacancies.church</title>
        <meta
          key="description"
          name="description"
          content="Send us a message at Vacancies.church about any issues you may have"
        />
        <meta
          key="ogdescription"
          property="og:description"
          content="Send us a message at Vacancies.church about any issues you may have"
        />
      </Head>
      <Header />
      <Container>
        <Row sm="1" md="3">
          <Col md="3" className="d-none d-md-block"></Col>
          <Col md="6" sm="12">
            <h1>Contact us</h1>
            <p>Please send us a message via the form below:</p>
            {submitted ? (
              <>
                <Alert color="success">Message sent successfully</Alert>
              </>
            ) : (
              <>
                <Form
                  onSubmit={(e) => {
                    if (validForm()) {
                      postMessageData();
                    } else {
                      console.log("invalid form");
                    }
                    e.preventDefault();
                  }}
                >
                  <FormGroup row>
                    <Col sm={12}>
                      <Label
                        for="name"
                        //sm={2}
                      >
                        Name
                      </Label>
                      <Input
                        key="name"
                        value={name}
                        invalid={
                          (name && name.length > 64) ||
                          (formSubmitted && (!name || name?.length == 0))
                        }
                        placeholder="Name"
                        onChange={(e) => setName(e.target.value)}
                      />
                      <FormFeedback>
                        Name must be entered and no more than 64 characters
                      </FormFeedback>
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <Col sm={12}>
                      <Label
                        for="email"
                        //sm={2}
                      >
                        Email
                      </Label>
                      <Input
                        key="email"
                        value={email}
                        invalid={
                          (email && email.length > 64) ||
                          (formSubmitted && (!email || email?.length == 0))
                        }
                        placeholder="Email" //TODO smarter email validation
                        onChange={(e) => setEmail(e.target.value)}
                      />
                      <FormFeedback>
                        Email must not be greater than 64 characters
                      </FormFeedback>
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <Col sm={12}>
                      <Label
                        for="message"
                        //sm={2}
                      >
                        Message
                      </Label>
                      <Input
                        value={message}
                        placeholder="Message"
                        invalid={
                          formSubmitted &&
                          (!message ||
                            message?.length < 5 ||
                            wordCount(message) < 2)
                        }
                        onChange={(e) => setMessage(e.target.value)}
                      />
                      <FormFeedback>
                        Message must be more than 5 characters and at least
                        two words
                      </FormFeedback>
                    </Col>
                  </FormGroup>
                  {/* honeypot: hidden from people, bots fill it in */}
                  <div
                    aria-hidden="true"
                    style={{ position: "absolute", left: "-10000px" }}
                  >
                    <Input
                      name="website"
                      tabIndex={-1}
                      autoComplete="off"
                      value={website}
                      onChange={(e) => setWebsite(e.target.value)}
                    />
                  </div>
                  <FormGroup row>
                    <Col>
                      <Button color="primary">Send</Button>
                    </Col>
                  </FormGroup>
                </Form>
              </>
            )}
          </Col>
          <Col md="3" className="d-none d-md-block"></Col>
        </Row>
      </Container>
      <Footer />
    </>
  );
};

export const getServerSideProps = withAuthUserTokenSSR()();

export default withAuthUser()(Contact);
